import type { ReactNode } from 'react';
import Folha from '@/components/movimento/Folha';

interface ModalProps {
  aberto: boolean;
  titulo?: string;
  aoFechar: () => void;
  children: ReactNode;
  rodape?: ReactNode;
}

// No celular vira folha que sobe de baixo; no desktop fica centralizada.
// Fecha arrastando para baixo, com Esc, no X ou tocando fora.
export default function Modal({ aberto, titulo, aoFechar, children, rodape }: ModalProps) {
  return (
    <Folha
      aberto={aberto}
      titulo={titulo}
      aoFechar={aoFechar}
      rodape={rodape}
      zIndex={70}
      larguraMaxima="max-w-lg"
    >
      {children}
    </Folha>
  );
}